import getTimeStamp from '../utils/getTime';
import urlify from '../utils/urlify';
class ElementRenderer {
    /**
     * Creates an ElementRenderer object that creates a html representation of different messaging elements
     *
     * @param configuration optional - used for agent messages to show avatar
     */
    constructor(configuration) {
        /**
         * @returns html string representation of added elements
         */
        this.getResult = () => {
            if (this.result === '') {
                return '';
            }
            else {
                this.closeContainer(this.currentUserImage);
                this.removeAnchorTags();
                return this.result;
            }
        };
        /**
         * Adds tracking data to the attributes of an element
         *
         * @param arg tracking data object of an presentational object
         * @param html string where tracking data should be appended
         * @returns html string with added meta data if available
         */
        this.addTrackingMetaData = (arg, html) => {
            if (arg.metaData && arg.metaData.GACategory
                && arg.metaData.GALabel
                && arg.metaData.GAAction) {
                html += `data-gacategory="${arg.metaData.GACategory}"
                       data-galabel="${arg.metaData.GALabel}"
                       data-gaaction="${arg.metaData.GAAction}"`;
            }
            return html;
        };
        this.configuration = configuration;
        this.result = "";
        this.lastMessage = "";
        this.currentUserImage = null;
    }
    /**
     * Returns html string of a message container for a participant that includes an avatar (bot/agent)
     */
    getNewUserMessageContainer() {
        $('.js-cbot-current-avatar').removeClass('js-cbot-current-avatar');
        $('.js-cbot-current-message-container').removeClass('js-cbot-current-message-container');
        return `<div class="cbot-bot">
    <div class="cbot-bot__content">
      <div class="cbot-bot__icon js-cbot-current-avatar">
        <img src="${this.getImageSrcFromConfiguration()}"/>
      </div>
      <div class="cbot-bot__messages js-cbot-current-message-container">
      </div>
    </div>
    </div>`;
    }
    /**
     * @returns Jquery element of current message container for active participant
     */
    getCurrentMessageContainer() {
        return $('.js-cbot-current-message-container');
    }
    /**
     * Set user image
     * @param user agent
     */
    setUserImage(user) {
        if (this.currentUserImage != user) {
            this.closeContainer(this.currentUserImage);
            this.currentUserImage = user;
            if (this.currentUserImage == "bot" || this.currentUserImage == "agent") {
                this.result +=
                    `<div class="cbot-bot">
                <div class="cbot-bot__content">
                  <div class="cbot-bot__icon">
                    <img src="${this.getImageSrcFromConfiguration()}"/>
                    {{DebugInfo}}
                  </div>
                  <div class="cbot-bot__messages">`;
            }
        }
    }
    /**
     * Close open message container for active user
     * @param user active user container
     */
    closeContainer(user) {
        switch (user) {
            case 'bot':
                this.result += "</div></div></div>";
                break;
            case 'agent':
                this.result += "</div></div></div>";
                break;
            case 'client':
                break;
            case 'system':
                break;
        }
    }
    /**
     * @returns string URL for active user avatar or empty string if not existant
     */
    getImageSrcFromConfiguration() {
        let srcString = "botavatar";
        switch (this.currentUserImage) {
            case 'bot':
                srcString = "botavatar";
                break;
            case 'agent':
                srcString = "a1avatar";
                break;
        }
        if (this.configuration) {
            return this.configuration.assetBase + this.configuration.images[srcString];
        }
        return "";
    }
    /**
     * Add text element
     * @param arg object with text string
     */
    addText(arg) {
        /*
        <div class="bot__messages">
            <div class="bot__message">
                Hi <span class="bot__message--highlight">Max</span>! Schön dich zu sehen.
            </div>
        </div>
        */
        if (arg.text !== null && arg.text !== undefined && arg.text !== '') {
            let urlifiedText = arg.text;
            if (!arg.text.startsWith('<iframe ')) {
                urlifiedText = urlify(arg.text.replace(/\n/g, "<br />"));
            }
            let html = `<div class="cbot-bot__message">
                      ${urlifiedText}
                      <span class="cbot-bot__message--sent">${getTimeStamp()}</span>
                  </div>`;
            this.lastMessage += html;
            this.result += html;
        }
    }
    /**
     * Add Button prepend to result
     */
    buttonPrepend() {
        let html = '<div class="cbot-bot__buttons">';
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add Button append to result
     */
    buttonAppend() {
        let close = "</div>";
        this.lastMessage += close;
        this.result += close;
    }
    /**
     * Add Button prepend image to result
     */
    buttonPrependImage() {
        let html = '<div class="cbot-bot__buttons cbot-bot__image-btn mt-0">';
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add Button to result
     * @param arg button object
     */
    addButton(arg) {
        /*
            <div class="bot__buttons">
                <button href="" class="btn">A1 NetCube+ Video</button>
                <button href="" class="btn">A1 NetCube Video</button>
            </div>
        */
        let html = "";
        if (!arg.actions.textback && arg.actions.url && arg.actions.urlTarget) {
            html += `<button href="javascript:void(0)"
                        data-url="${arg.actions.url}"
                        data-urltarget="${arg.actions.urlTarget}"`;
            html = this.addTrackingMetaData(arg, html);
            html += `class="cbot-btn link-button jsClickableWithExternalTarget">
                        ${arg.text}
                      </button>`;
        }
        else {
            if (!arg.actions.textback && arg.actions.commandName && arg.actions.commandOptions) {
                html += `<button href="javascript:void(0)"`;
                html = this.addTrackingMetaData(arg, html);
                html += `data-commandname="${arg.actions.commandName}"
          data-commandoptions=` + encodeURI(JSON.stringify(arg.actions.commandOptions)) + `
          class="cbot-btn jsClickableCommandButton">
          ${arg.title}
      </button>`;
            }
            else {
                html += `<button href="javascript:void(0)"
                        data-textback="${arg.actions.textback}"
                        class="cbot-btn jsClickable">
                        ${arg.title}
                      </button>`;
            }
        }
        this.lastMessage += html;
        this.result += html;
    }
    quickReplyPrepend() {
        let html = '<div class="cbot-quickreplies">';
        this.lastMessage += html;
        this.result += html;
    }
    quickReplyAppend() {
        let html = '</div>';
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Adds quick reply element to the result
     * @param arg quickreply object
     * @param index identifier for quickreply
     */
    addQuickReply(arg, index) {
        /*
            <div class="bot__messages">
              <div class="bot__message">
                Info Teil eins
              </div>
              <!-- quickreplies--hidden is display none -->
              <div class="quickreplies">
                <a href="" class="quickreplies__link">Kabel geht</a>
                <a href="" class="quickreplies__link">Klappt nicht</a>
                <a href="" class="quickreplies__link">Welches Kabel?</a>
                <a href="" class="quickreplies__link">kein Wlan</a>
              </div>
            </div>
        */
        let quickReplyNumber = 'quickreplies_' + index;
        let html = `<a href="javascript:void(0)"
                  class="cbot-quickreplies__link jsClickable ${quickReplyNumber}"
                      data-textback="${arg.text}"
                      data-messageclass="${index}">
                      ${arg.text}
                </a>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add image to the result
     *
     * @param arg image object
     */
    addImage(arg) {
        /*
            <div class="bot__message no-padding">
                <img src="images/placeholder.png" aria-hidden="true"/>
            </div>
    
            <div class="bot__buttons bot__image-btn mt-0">
                <button href="" class="btn">A1 NetCube+ Video</button>
            </div>
        */
        // console.log(arg);
        let html = `<div class="cbot-bot__message no-padding">
                <a
                  href="${(arg.actions && arg.actions.url) ? arg.actions.url : undefined}"
                  target="${(arg.actions && arg.actions.urlTarget) ? arg.actions.urlTarget : undefined}"
                  class="jsClickableTracking"`;
        html = this.addTrackingMetaData(arg, html);
        html += `>
                        <img src="${arg.image}" aria-hidden="true"/>
                      </a>
                    </div>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add video to the result
     * @param arg video object
     */
    addVideo(arg) {
        /*
            <div class="bot__message no-padding">
                <img src="images/placeholder.png" aria-hidden="true"/>
            </div>
    
            <div class="bot__buttons bot__image-btn mt-0">
                <button href="" class="btn">A1 NetCube+ Video</button>
            </div>
        */
        // console.log(arg);
        let html = `<div class="cbot-bot__message no-border">
                      <video width="100%" height="100%" controls>
                       <source src="${arg.video}">
                       Your browser does not support the video tag.
                      </video>
                    </div>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add typing animation to the object. Needs configuration set.
     */
    addTyping() {
        return `<!-- Typing Bot but with a1 Avatar -->
      <div class="cbot-bot-typing-wrapper">
        <div class="cbot-bot__content">
        <div class="cbot-bot__icon"><img src="${this.getImageSrcFromConfiguration()}"/></div>
        <div class="cbot-bot__messages">
          <div class="cbot-bot__message  cbot-bot--typing">
            <div class="cbot-typing">
              <div class="cbot-typing__block">
                <div class="cbot-typing__dot"></div>
                <div class="cbot-typing__dot"></div>
                <div class="cbot-typing__dot"></div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>`;
    }
    /**
     * Add system message to the result
     * @param text string that should be displayed as system message
     */
    addSystemMessage(text) {
        let html = `<p class="cbot-systemMessage">${text}</p>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add user input message to the result
     * @param userInput string that should be displayed
     */
    addUserInput(userInput) {
        if ('string' === typeof userInput) {
            userInput = userInput.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            userInput = userInput.replace(/&lt;br&gt;/g, '<br>');
            let html = `
        <div class="cbot-user">
            <div class="cbot-user__message">
                ${userInput}
                <span class="cbot-bot__message--sent">${getTimeStamp()}</span>
            </div>
        </div>
       `;
            this.lastMessage += html;
            this.result += html;
        }
    }
    /**
     * Add carousel to result
     *
     * @param structuredContent carousel object
     * @param index identifier for carousel
     */
    addCarousel(structuredContent, index) {
        let galleryNumber = 'gallery_' + index;
        //   <div class="cbot-galleryItem">
        //     <img class="cbot-galleryItem__img" src="images/gallery-img.png">
        //       <div class="cbot-galleryItem__content">
        //         <div class="cbot-galleryItem__title">
        //           Titel of Image
        //         </div>
        //         <p class="cbot-galleryItem__text">
        //           Description of image if exists
        //         </p>
        //       </div>
        //       <button href="" class="cbot-btn cbot-galleryItem__button cbot-btn__secondary">A1 NetCube+Video</button>
        // </div>
        let html = `<div class="cbot-gallery ${galleryNumber}">`;
        for (let contentEntry of structuredContent.content) {
            // console.log(contentEntry);
            html += `<div class="cbot-galleryItem">`;
            html += `<div class="cbot-galleryItemHeader">`;
            if (contentEntry.image) {
                html += `
        <a
            href="${contentEntry.actions.url ? contentEntry.actions.url : undefined}"
            target="${contentEntry.actions.urlTarget ? contentEntry.actions.urlTarget : undefined}"
            class="jsClickableTracking"`;
                html = this.addTrackingMetaData(contentEntry, html);
                html += `>
            <img class="cbot-galleryItem__img" src="${contentEntry.image}" aria-hidden="true"/>
        </a>`;
            }
            html += `</div>`;
            html += `<div class="cbot-galleryItemBody">`;
            if (contentEntry.title || contentEntry.desc) {
                html += `<div class="cbot-galleryItem__content">`;
                if (contentEntry.title) {
                    html += `<div class="cbot-galleryItem__title">${contentEntry.title}</div>`;
                }
                if (contentEntry.desc) {
                    html += `<p class="cbot-galleryItem__text">${contentEntry.desc}</p>`;
                }
                html += `</div>`;
            }
            html += `</div>`;
            html += `<div class="cbot-galleryItemFooter">`;
            if (contentEntry['components']) {
                let buttonDiv = false;
                for (let component of contentEntry['components']) {
                    if (component.type && component.type === 'button') {
                        if (!buttonDiv) {
                            buttonDiv = true;
                            html += `<div class="cbot-bot__buttons">`;
                        }
                        if (!component.actions.textback && component.actions.url && component.actions.urlTarget) {
                            html += `<button href="javascript:void(0)"
                                data-url="${component.actions.url}"
                                data-urltarget="${component.actions.urlTarget}"`;
                            html = this.addTrackingMetaData(component, html);
                            html += `class="cbot-btn cbot-galleryItem__button cbot-btn__primary link-button jsClickableWithExternalTarget">
                                ${component.text}
                              </button>`;
                        }
                        else {
                            html += `<button href="javascript:void(0)"
                                data-textback="${component.actions.textback}"`;
                            html = this.addTrackingMetaData(component, html);
                            html += `class="cbot-btn cbot-galleryItem__button cbot-btn__primary jsClickable">
                                ${component.title}
                              </button>`;
                        }
                    }
                    else if (buttonDiv) {
                        html += `</div>`;
                        buttonDiv = false;
                    }
                }
                if (buttonDiv) {
                    html += `</div>`;
                    buttonDiv = false;
                }
            }
            html += `</div>`;
            html += `</div>`;
        }
        html += `</div>`;
        let galleryNumberSelector = `$('.${galleryNumber}')`;
        html += `<script>${galleryNumberSelector}.initalizeGallery()</script>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * Add download button to result
     * @param userData object that contains file information
     * @param widget widget object to access api and sessionData
     */
    addDownloadButton(userData, widget) {
        const alias = widget.sessionData.alias ? widget.sessionData.alias : undefined;
        const secureKey = widget.sessionData.secureKey ? widget.sessionData.secureKey : undefined;
        const userId = widget.sessionData.userId ? widget.sessionData.userId : undefined;
        const sessionId = widget.sessionData.sessionID ? widget.sessionData.sessionID : undefined;
        const fileId = userData['file-id'] ? userData['file-id'] : undefined;
        const fileName = userData['file-name'] ? userData['file-name'] : undefined;
        const action = widget.intObj.getFileUpload(sessionId) + '/' + fileId + '/download';
        const uploadButtonDivTemplate = document.createElement("div");
        uploadButtonDivTemplate.classList.add('cbot-bot__buttons');
        const uploadButtonTemplate = document.createElement("button");
        uploadButtonTemplate.classList.add('cbot-btn', 'cbot-btn__primary', 'cbot-download__buttons');
        uploadButtonTemplate.setAttribute('data-action', action);
        uploadButtonTemplate.setAttribute('data-alias', alias);
        uploadButtonTemplate.setAttribute('data-secureKey', secureKey);
        uploadButtonTemplate.setAttribute('data-userId', userId);
        uploadButtonTemplate.innerHTML = fileName;
        uploadButtonDivTemplate.appendChild(uploadButtonTemplate);
        this.lastMessage += uploadButtonDivTemplate.outerHTML;
        this.result += uploadButtonDivTemplate.outerHTML;
    }
    /**
     * Adds debug info to a message from the bot
     * @param debugInfo debug info event from bot
     */
    addDebugInfo(debugInfo) {
        let wAResponse = debugInfo.debug.wAResponse;
        if (!wAResponse) {
            wAResponse = debugInfo.debug;
        }
        wAResponse = encodeURI(JSON.stringify(wAResponse, null, "\t"));
        let html = `<a class="cbot-debugInfo__button jsClickDebugInfo" data-debuginfo="${wAResponse}">
                    <i class="cbot-icon-bug-solid" aria-hidden="true"></i> 
                </a>`;
        this.result = this.result.replace("{{DebugInfo}}", html);
        $('.js-cbot-current-avatar').append(html);
    }
    addInvoiceElement(invoiceEvent) {
        let html = `<div class="cbot-invoice" data-ban="${invoiceEvent.ban}" data-ben="${invoiceEvent.ben}"
                  data-vk="${invoiceEvent.vk}" ><div class="cbot-loader" title="Bitte warten…" style="display: block">
                  <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
                      viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                      <path fill="#000"
                          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
                              to="360 25 25" dur="1s" repeatCount="indefinite" />
                      </path>
                  </svg>
              </div></div>`;
        this.lastMessage += html;
        this.result += html;
    }
    /**
     * removes anchor tags from the html result string
     */
    removeAnchorTags() {
        this.result = this.result.replace(/{{DebugInfo}}/g, "");
    }
    /**
     * Get current message as html string
     * @returns html string of currently processed message
     */
    getCurrentMessage() {
        let message = this.lastMessage;
        this.lastMessage = "";
        return message;
    }
    /**
     * Get current participant for currently processed message
     */
    getCurrentUser() {
        return this.currentUserImage;
    }
}
export { ElementRenderer };
